export default __webpack_public_path__ + "static/media/7A1_1978-1-2.844a61ab.png";